import React, { FormEvent, ReactNode } from "react";

import { AnswerTemplate } from "../../db/models/Answer";
import { useTranslate } from "../translation/frontend";

export default function ReportFormMain({
  children,
  onSubmit,
  csrfToken,
  pageHistory,
  formRef,
  answers,
  loading,
  sessionId,
}: {
  children: ReactNode;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  csrfToken: string;
  pageHistory: number[];
  formRef: React.Ref<HTMLFormElement>;
  answers: Record<string, AnswerTemplate[]>;
  loading: boolean;
  sessionId: string;
}) {
  const translate = useTranslate();

  return (
    <form
      method="post"
      encType="multipart/form-data"
      className={`form ${loading ? "loading" : ""}`}
      onSubmit={onSubmit}
      ref={formRef}
    >
      {loading ? (
        <div className="loading-cover">
          <div className="loading-cover__modal">
            <span className="loading-cover__main">{translate("sendingReport")}</span>
            <span className="loading-cover__detail">{translate("doNotCloseTab")}</span>
          </div>
        </div>
      ) : null}
      <input type="hidden" name="_csrf" value={csrfToken} />
      <input type="hidden" name="_page" value={pageHistory.join(",")} />
      <input type="hidden" name="sessionId" value={sessionId} />
      <input type="hidden" name="previous-answers" value={JSON.stringify(answers)} className="hidden-answer-field" />
      {children}
    </form>
  );
}
